import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { timingBridgeAPI, publicTimingAPI } from '../lib/api';
import BroadcastTiming from '../components/broadcast/BroadcastTiming';

/** In Mission Control, for the team: /broadcast/timing/:showId (needs a login). */
export function BroadcastTimingPage() {
  const { showId } = useParams();
  const load = useCallback(() => timingBridgeAPI.view(showId).then(res => res.data), [showId]);
  return <BroadcastTiming load={load} />;
}

/** By share link, for commentators: /timing/:token (no login). */
export function SharedTimingPage() {
  const { token } = useParams();
  const load = useCallback(() => publicTimingAPI.view(token), [token]);
  return <BroadcastTiming load={load} />;
}
